"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash = void 0;
var sha1 = require('cifre/sha1');
var utils = require('cifre/utils');
function hash(value) {
    if (value === undefined) {
        value = '';
    }
    var inBuffer = utils.stringToBuffer(JSON.stringify(value));
    var buffer = sha1(inBuffer);
    return utils.tohex(buffer);
}
exports.hash = hash;
//# sourceMappingURL=hash.js.map